import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import AddPassengerDisplay from 'formiojs/components/textfield/editForm/TextField.edit.display';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: AddPassengerDisplay,
    },
    {
      key: 'data',
      ignore: false,
    },
    {
      key: 'validation',
      ignore: false,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 50,
          type: 'textfield',
          label: 'Custom description',
          key: 'customDescription',
          input: true,
        },
        {
          weight: 50,
          type: 'textfield',
          label: 'Add passenger button label',
          key: 'addPassengerButtonLabel',
          input: true,
        },
        {
          weight: 50,
          type: 'textfield',
          label: 'Add another passenger button label',
          key: 'addAnotherPassengerButtonLabel',
          input: true,
        },
        {
          weight: 50,
          type: 'textfield',
          label: 'Add person section title',
          key: 'addPersonTitle',
          input: true,
        },
        {
          weight: 50,
          type: 'textfield',
          label: 'Confirm person button label',
          key: 'confirmLabel',
          input: true,
        },
        {
          weight: 50,
          type: 'checkbox',
          label: 'is AB only claim',
          key: 'isAbOnlyClaim',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
